import { buildQuery } from '../../../utils/query';

export default {
  GET_BRANCHES: ({ page = 1, rowsPerPage = 100, searchTerm } = {}) =>
    `attributes/locations/${buildQuery({ page, page_size: rowsPerPage, search_term: searchTerm })}`,
  GET_AUDIT_BRANCHES: 'attributes/branches',
  CREATE_BRANCH: 'attributes/locations/',
  UPDATE_BRANCH: (id) => `attributes/locations/${id}/`,
  DELETE_CATEGORY: (id) => `customers/${id}/delete/`,
};
